import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { configureAxios } from "./common/axios/axiosInterceptor";
import { AppRouts } from "./routes/AppRoutes";
import "./App.css";
import AuthProvider, { useAuth } from "./context/AuthContext";
function App() {
  const { setIsAuth } = useAuth();

  useEffect(() => {
    configureAxios(setIsAuth);
  }, [setIsAuth]);
  return (
    <div className="App">
      <Router>
        <AppRouts />
      </Router>
    </div>
  );
}

export default App;
